import * as COMMON from "../constants";
import { OverlayListener } from "./OverlayListener";
export class DrawerHandler {
  overlayListener?: OverlayListener;
  constructor(readonly overlay: Element | null) {
    if (this.overlay) {
      this.overlayListener = new OverlayListener(this.overlay);
    }
  }

  handler(this: Element, handler: DrawerHandler, e: Event) {
    e.stopPropagation();
    const ariaControls: string[] | undefined = this.getAttribute("aria-controls")?.split(/\s/);
    if (!ariaControls) return console.error("aria-controls is null");
    const targets: (HTMLElement | null)[] = ariaControls.map((control) => document.getElementById(control));
    if (
      this.classList.contains(COMMON.CLASS_NAMES.IS_ACTIVE) ||
      this.getAttribute("aria-expanded") === "true" ||
      this.tagName === "A"
    ) {
      handler.close(this, targets);
      handler.overlayListener?.unlisten(handler.close, [this, targets]);
    } else {
      handler.open(this, targets);
      handler.overlayListener?.listen(handler.close, [this, targets]);
    }
  }

  /**
   * Drawerを開く
   * @method open
   *
   * @param {Element} trigger
   * @param {(HTMLElement | null)[]} targets
   */
  open(trigger: Element, targets: (HTMLElement | null)[]): void {
    trigger.classList.add(COMMON.CLASS_NAMES.IS_ACTIVE);
    if (trigger.hasAttribute("aria-expanded")) {
      trigger.setAttribute("aria-expanded", "true");
    }
    targets.forEach((target: HTMLElement | null) => {
      if (!target) return;
      target.classList.add(COMMON.CLASS_NAMES.IS_ACTIVE);
      if (target.hasAttribute("aria-hidden")) {
        target.setAttribute("aria-hidden", "false");
      }
    });
    return;
  }

  /**
   * Drawerを閉じる
   * @method close
   *
   * @param {Element} trigger
   * @param {(HTMLElement | null)[]} targets
   */
  close(trigger: Element, targets: (HTMLElement | null)[]): void {
    trigger.classList.remove(COMMON.CLASS_NAMES.IS_ACTIVE);
    if (trigger.hasAttribute("aria-expanded")) {
      trigger.setAttribute("aria-expanded", "false");
    }
    targets.forEach((target) => {
      if (!target) return;
      target.classList.remove(COMMON.CLASS_NAMES.IS_ACTIVE);
      if (target.hasAttribute("aria-expanded")) {
        target.setAttribute("aria-expanded", "false");
      }
      if (target.hasAttribute("aria-hidden")) {
        target.setAttribute("aria-hidden", "true");
      }
    });
  }
}
